import { render, staticRenderFns } from "./DteTotalsSection.vue?vue&type=template&id=a56d2e98"
import script from "./DteTotalsSection.vue?vue&type=script&lang=js"
export * from "./DteTotalsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports